import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manager-msg',
  templateUrl: './manager-msg.component.html',
  styleUrls: ['./manager-msg.component.css']
})
export class ManagerMsgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
